import SelectOmDialog from '@/pages/MainPage/dialogs/SelectOmDialog'
import InputModalSelect from '../components/InputModalSelect.jsx'

export default function SelectOm({value, ...props}) {
    const getText = multiple => multiple ?
        (value ?? []).map(({omName}) => omName).join(',') :
        (value ?? {}).omName

    return (
        <InputModalSelect
            getText={getText}
            Modal={SelectOmDialog}
            {...props}
        />
    )
}
